export interface Request {
	'organizations'?: any,
	'roles'?: any,
	'permissions'?: any,
	'device_types'?: any,
	'devices'?: any,
	'assets'?: any,
	'applications'?: any,
	'software_version'?: any,
	'device_applications'?: any,
	'request_messages'?: any,
	'command_config_messages'?: any,
	'command_software_messages'?: any,
	'message_aduit_log'?: any,
	'registration_requests'?: any,
	'device_state_history'?: any,
	'alert_messages'?: any,
	'dashboard_counters'?: any,
	'provisioning_requests'?: any,
	'artifact_repository'?: any,
	'artifact_download_queue'?: any,
	'device_configuration_profiles'?: any,
	'request_command_messages'?: any,
	'asset_logs'?: any,
	'startup_parameters'?: any,
	'command_status_history'?: any,
	'command_install_history'?: any,
	'device_registration_history'?: any,
	'device_provisioning_history'?: any,
	'device_provisioning_applications'?: any,
	'provisioning_software_messages'?: any,
	'configuration_packages'?: any,
	'configuration_artifacts'?: any,
	'device_configuration_packages'?: any,
	'device_configuration_packages_history'?: any,
	'device_graphs'?: any,
	'pki_certificate_commands'?: any,
	'alarm_configuration'?: any,
	'release_manager'?: any,
	'deployment_manager'?: any,
	'deployment_manager_workflow'?: any,
	'tools'?: any
}

export const RequestUrls: Request = {
	'device_graphs': {
		'search': 'devicemgt/v1/device/heartbeat/search',
		'deviceHealth': 'devicemgt/v1/devicemetrics/data'
	},
	'organizations': {
		'list': 'devicemgt/v1/organizations',
		'listByItcm': 'devicemgt/v1/organizations/itcm/',
		'itcmConfig': 'devicemgt/v1/organizations/itcm/configuration/',
		'listByProfile': 'devicemgt/v1/organizations/by-profile/',
		'listByApplication': 'devicemgt/v1/organizations/application/',
		'count': 'devicemgt/v1/organizations/count',
		'update': 'devicemgt/v1/organizations',
		'delete': 'devicemgt/v1/organizations',
		'listbydevices': 'devicemgt/v1/devices/orgs'
	},
	'roles': {
		'list': 'devicemgt/v1/roles',
		'count': 'devicemgt/v1/roles/count',
		'create': 'devicemgt/v1/roles',
		'update': 'devicemgt/v1/roles',
		'delete': 'devicemgt/v1/roles',
		'modifyStatus': 'devicemgt/v1/roles',
		'listBySearch': 'devicemgt/v1/roles/list/search',
		'permissions': 'devicemgt/v1/roles/rolepermissions'
	},
	'permissions': {
		'list': 'devicemgt/v1/permissions'
	},
	'device_types': {
		'list': 'devicemgt/v1/devicetypes',
		'count': 'devicemgt/v1/devicetypes/count',
		'search': 'devicemgt/v1/devicetypes/list/search',
		'create': 'devicemgt/v1/devicetypes',
		'delete': 'devicemgt/v1/devicetypes',
		'modifystatus': 'devicemgt/v1/devicetypes',
		'defaultConfig': 'devicemgt/v1/devicetypes/default/config/',
		'listbyactive': 'devicemgt/v1/devicetypes/status/active'
	},
	'devices': {
		'list': 'devicemgt/v1/devices',
		'count': 'devicemgt/v1/devices/count',
		'create': 'devicemgt/v1/devices',
		'update': 'devicemgt/v1/devices',
		'delete': 'devicemgt/v1/devices',
		'countOrgs': 'devicemgt/v1/devices/count/orgs',
		'listOrgSearch': 'devicemgt/v1/devices/list/org/search',
		'bySoftVersion': 'devicemgt/v1/devices/by-software-version/',
		'countBySoftVersion': 'devicemgt/v1/devices/count/by-software-version/',
		'searchBySoftVersion': 'devicemgt/v1/devices/search/by-software-version/',
		'getByOrgGuid': 'devicemgt/v1/devices/byorgguid/',
		'countByOrgGuid': 'devicemgt/v1/devices/count/byorgguid/',
		'listSearch': 'devicemgt/v1/devices/list/search',
		'bulkUpload': 'devicemgt/v1/devices/bulk/upload/',
		'countRegRequest': 'devicemgt/v1/devices/count/regrequest',
		'searchByRegRequest': 'devicemgt/v1/devices/search/regrequest',
		'NotAssociatedRegRequest': 'devicemgt/v1/devices/not/associated/regRequest',
		'searchByProvRequest': 'devicemgt/v1/devices/search/prorequest',
		'countByProvRequest': 'devicemgt/v1/devices/count/provisional/request',
		'countAssetsList': 'devicemgt/v1/devices/count/assets/list',
		'countByOrgGuidAssets': 'devicemgt/v1/devices/count/byorgguid/assets/',
		'assetsListSearch': 'devicemgt/v1/devices/list/assets/search',
		'modifystatus': 'devicemgt/v1/devices',
		'getdeviceid': 'devicemgt/v1/devices/getdeviceid',
		'registrationcomplete': 'devicemgt/v1/devices/registration/complete/list/search',
		'registrationcompletebyprofile': 'devicemgt/v1/devices/search/registration/complete/profile/',
		'countbyprofileregistrationcomplete': 'devicemgt/v1/devices/count/profile/',
		'NotAssociatedProvRequest': 'devicemgt/v1/devices/not/associated/provisioning/requst',
		'deviceRegisStatus': 'devicemgt/v1/devices/registration/status/',
		'deploymentTargetedDevicesCount': 'devicemgt/v1/devices/target-devices/count/',
		'deploymentTargetedDevicesList': 'devicemgt/v1/devices/target-devices/',
		'deploymentTargetedDevicesListSearch': 'devicemgt/v1/devices/target-devices/search/',
		'deploymentTargetedDevicesCountNotAssociated': 'devicemgt/v1/devices/target-devices/not-associated/count/',
		'deploymentTargetedDevicesListNotAssociated': 'devicemgt/v1/devices/target-devices/not-associated/',
		'deploymentTargetedDevicesCountNotAssociatedSearch': 'devicemgt/v1/devices/target-devices/not-associated/search/',
		'targetGroupAssetRange': 'devicemgt/v1/devices/target-devices/not-associated/assets/',
		'targetGroupAssetRangeCount': 'devicemgt/v1/devices/target-devices/not-associated/count/assets/',
		'searchDeploymentTargetGroupAssetRange': 'devicemgt/v1/devices/target-devices/not-associated/search/assets/',
		'searchDevicesByOrgGuid': 'devicemgt/v1/devices/organization-dashboard/search'

	},
	'assets': {
		'list': 'devicemgt/v1/assets',
		'listByGuid': 'devicemgt/v1/assets/byguid/',
		'listByOrgGuid': 'devicemgt/v1/assets/byorgguid/',
		'listbydevice': 'devicemgt/v1/devices/assets/list',
		'listbyprofile': 'devicemgt/v1/assets/by-profile/',
		'searchbyprofile': 'devicemgt/v1/assets/by-profile/search/',
		'listbyprofileCount': 'devicemgt/v1/assets/by-profile/count/',
		'listbyorg': 'devicemgt/v1/devices/byorgguid/assets/',
		'devicelistbyasset': 'devicemgt/v1/devices/byassetguid/',
		'assetsByRange': 'devicemgt/v1/assets/by-profile/get-asset-range/',
		'updateAssetsRange': 'devicemgt/v1/assets/by-profile/update-asset-range/',
		'addAssetsRange': 'devicemgt/v1/assets/by-profile/add-asset-range/',
		'byProfileRangeCount': 'devicemgt/v1/assets/by-profile/range-count/',
		'assetsByRangeList': 'devicemgt/v1/assets/by-profile/range-list/',
		'assetsByRangeSearch': 'devicemgt/v1/assets/by-profile/range-list/search/',
		'assetsByRangeRefresh': 'devicemgt/v1/assets/by-profile/refresh-asset-range/',
		'byProfileDeleteRange': 'devicemgt/v1/assets/by-profile/delete-range/',
		'notAssociatedProfile': 'devicemgt/v1/assets/by-profile/not-associated/',
		'ByProfileNotAssociated': 'devicemgt/v1/assets/by-profile/range-list/not-associated/',
		'ByProfileRangeCountNotAssociated': 'devicemgt/v1/assets/by-profile/range-count/not-associated/',
		'countdevicesbyasset': 'devicemgt/v1/devices/count/byassetguid/'
	},
	'applications': {
		'list': 'devicemgt/v1/applications',
		'searchNotAssociatedByProfile': 'devicemgt/v1/applications/search/not-associated/by-profile/',
		'listNotAssociatedByProfile': 'devicemgt/v1/applications/list/not-associated/by-profile/',
		'countNotAssociatedByProfile': 'devicemgt/v1/applications/count/not-associated/by-profile/',
		'count': 'devicemgt/v1/applications/count',
		'listSearch': 'devicemgt/v1/applications/list/search',
		'countByProfile': 'devicemgt/v1/applications/count/profile/',
		'listByOrganization': 'devicemgt/v1/applications/search/organization/',
		'countByOrganization': 'devicemgt/v1/applications/count/organization/',
		'associateApplicationByProfile': 'devicemgt/v1/applications/associate-application/by-profile/',
		'create': 'devicemgt/v1/applications',
		'update': 'devicemgt/v1/applications',
		'delete': 'devicemgt/v1/applications',
		'modifystatus': 'devicemgt/v1/applications',
		'profileAssociatedApps': 'devicemgt/v1/applications/profile-associated-apps/',
		'provisioningAssociatedApps': 'devicemgt/v1/applications/provisioning-associated-apps/',
		'profiledetailsview': 'devicemgt/v1/applications/device/configuration/profile/',
		'readbyorganizationscope': 'devicemgt/v1/applications/read/organization-scope',
		'validateOemAppSelection': 'devicemgt/v1/applications/validate/oem-app-flag/',
		'readOrgScopeByProfile': 'devicemgt/v1/applications/read/organization-scope/by-profile/',
		'listAddSwArtifact': 'devicemgt/v1/applications/add/software/version/artifact/',
		'childApp': 'devicemgt/v1/applications/child-app/',
	},
	'software_version': {
		'list': 'devicemgt/v1/softwareversion',
		'countByOrgGuid': 'devicemgt/v1/softwareversion/count/by-org/',
		'searchByOrgGuid': 'devicemgt/v1/softwareversion/search/by-org/',
		'listSearchOrgsByApp': 'devicemgt/v1/softwareversion/search/organization/application/',
		'getProfileApp': 'devicemgt/v1/softwareversion/get-profile-app/',
		'profileBulkSoftwareVersion': 'devicemgt/v1/softwareversion/profile-associated-soft-versions/',
		'deviceUpdatesAssociatedSofVersionInstall': 'devicemgt/v1/softwareversion/associated-soft-versions-device-updates-install/',
		'deviceUpdatesAssociatedSofVersionDownload': 'devicemgt/v1/softwareversion/associated-soft-versions-device-updates-download/',
		'provisioningUpdatesAssociatedSofVersionDownload': 'devicemgt/v1/softwareversion/associated-soft-versions-provisioning-updates-download/',
		'listByOrg': 'devicemgt/v1/softwareversion/org/',
		'associateOrgScope': 'devicemgt/v1/softwareversion/associate/org/scope/',
		'countByOrg': 'devicemgt/v1/softwareversion/count/org/',
		'countByProfile': 'devicemgt/v1/softwareversion/count/profile/',
		'listByProfile': 'devicemgt/v1/softwareversion/profile/',
		'listByStartupParams': 'devicemgt/v1/softwareversion/startup-parameters/',
		'listbyapplication': 'devicemgt/v1/softwareversion/application/',
		'countbyapplication': 'devicemgt/v1/softwareversion/count/application/',
		'searchbyprofileapplication': 'devicemgt/v1/softwareversion/search/profile/',
		'searchbyapplication': 'devicemgt/v1/softwareversion/search/',
		'searchByOrg': 'devicemgt/v1/softwareversion/search/org/',
		'searchSoftVersion': 'devicemgt/v1/softwareversion/search/software/versions/',
		'searchByProfile': 'devicemgt/v1/softwareversion/search/profile/',
		'countbyprofile': 'devicemgt/v1/softwareversion/count/profile/application/',
		'listByProfileApp': 'devicemgt/v1/softwareversion/profile-application/',
		'createbyprofile': 'devicemgt/v1/softwareversion/profile/application',
		'readbyorganizationscope': 'devicemgt/v1/softwareversion/read/search/organization/scope/',
		'readOrgScopeByApp': 'devicemgt/v1/softwareversion/read/search/organization/scope/profile/application/',
		'readbyorganizationscopeByProfile': 'devicemgt/v1/softwareversion/read/search/organization/scope/profile/',
		'list_associated_to_config_version': 'devicemgt/v1/softwareversion/associated/toconfigversion/',
		'countByConfigPackage': 'devicemgt/v1/softwareversion/get-config-packages/count/',
		'listByConfigPackage': 'devicemgt/v1/softwareversion/get-config-packages/',
		'searchByConfigPackage': 'devicemgt/v1/softwareversion/get-config-packages/search/',
		'notAssociatedToConfigPackagesCount': 'devicemgt/v1/softwareversion/not/associated/software-versions/config-package/count/',
		'notAssociatedToConfigPackagesList': 'devicemgt/v1/softwareversion/not/associated/software-versions/config-package/list/',
		'notAssociatedToConfigPackagesSearch': 'devicemgt/v1/softwareversion/not/associated/software-versions/config-package/search/',
		'availableToDownloadForProvisioningUpdates': 'devicemgt/v1/softwareversion/get-software-versions-prov-updates/'
	},
	'device_applications': {
		'list': 'devicemgt/v1/device/applications',
		'installValidation': 'devicemgt/v1/device/applications/install/validation',
		'installValidationAutoStart': 'devicemgt/v1/device/applications/install/validation-auto-start',
		'saveDevApps': 'devicemgt/v1/device/applications/save-device-apps',
		'associateApps': 'devicemgt/v1/device/applications/associate/application',
		'listByConfigHistory': 'devicemgt/v1/device/applications/config/history',
		'searchConfigHistory': 'devicemgt/v1/device/applications/search/config/history/',
		'searchConfigHistoryCount': 'devicemgt/v1/device/applications/count/config/history/',
		'searchByDevice': 'devicemgt/v1/device/applications/search/bydevice/',
		'listByDevices': 'devicemgt/v1/device/applications/listby/devices/',
		'listByDevicesCount': 'devicemgt/v1/device/applications/listby/devices/count/',
		'notactivelist': 'devicemgt/v1/device/applications/notactive',
		'countnotactive': 'devicemgt/v1/device/applications/count/notactive',
		'currentstatus': 'devicemgt/v1/device/applications/listby/currentstatus',
		'countbycurrentstatus': 'devicemgt/v1/device/applications/listby/count/currentstatus',
		'searchbyprofile': 'devicemgt/v1/device/applications/search/byprofile/application/',
		'listbyprofileActive': 'devicemgt/v1/device/applications/listby/profile/application/',
		'listByProfile': 'devicemgt/v1/device/applications/list/by-profile/',
		'countByProfile': 'devicemgt/v1/device/applications/count/by-profile/',
		'searchByProfileInfo': 'devicemgt/v1/device/applications/search/by-profile/',
		'updateDeviceApplicationVersions': 'devicemgt/v1/device/applications/update/application/versions/'
	},

	'request_messages': {
		'post': 'devicemgt/v1/request'
	},

	'command_config_messages': {
		'delete': 'devicemgt/v1/command/software/configuration/',
		'download': 'devicemgt/v1/command/software/configuration/command.config.download',
		'apply': 'devicemgt/v1/command/software/configuration/command.config.apply',
		'update': 'devicemgt/v1/command/software/configuration/command.config.update',
		'reset': 'devicemgt/v1/command/software/configuration/reset/',
		'manualinstall': 'devicemgt/v1/command/software/configuration/manual.install',
		'user_selection_on_delete_action': 'devicemgt/v1/command/software/configuration/workflow-queue-actions/'
	},
	'command_software_messages': {
		'download': 'devicemgt/v1/command/software/command.software.download',
		'install': 'devicemgt/v1/command/software/command.software.install',
		'update': 'devicemgt/v1/command/software/command.software.update',
		'reset': 'devicemgt/v1/command/software/reset',
		'manualinstall': 'devicemgt/v1/command/software/manual.install',
		'reconfigure': 'devicemgt/v1/command/software/command.software.reconfigure',
		'uninstall': 'devicemgt/v1/command/software/command.software.uninstall',
		'start': 'devicemgt/v1/command/software/command.software.start',
		'stop': 'devicemgt/v1/command/software/command.software.stop',
		'logs': 'devicemgt/v1/command/software/command.software.logs',
		'stat': 'devicemgt/v1/command/software/command.software.stat',
		'reset_command_status': 'devicemgt/v1/command/software/reset/commandSatus/',
		'manual_download_success': 'devicemgt/v1/command/software/manual-download-success'

	},
	'provisioning_software_messages': {
		'download': 'devicemgt/v1/command/provisioning/software/provisioning.download.request',
		'install': 'devicemgt/v1/command/provisioning/software/provisioning.download.install',
		'reset': 'devicemgt/v1/provisioning/reset',
		'manualinstall': 'devicemgt/v1/command/provisioning/software/manual.install',
		'reconfigure': 'devicemgt/v1/command/provisioning/software/provisioning.download.reconfigure',
		'uninstall': 'devicemgt/v1/command/provisioning/software/provisioning.download.uninstall',
		'start': 'devicemgt/v1/command/provisioning/software/provisioning.download.start',
		'stop': 'devicemgt/v1/command/provisioning/software/provisioning.download.stop',
		'logs': 'devicemgt/v1/command/provisioning/software/command.software.logs',
		'stat': 'devicemgt/v1/command/provisioning/software/command.software.stat',
		'reset_command_status': 'devicemgt/v1/command/provisioning/software/reset/commandSatus/'
	},
	'message_aduit_log': {
		'listbydevices': 'devicemgt/v1/messageauditlog/bydevices/',
		'searchbydevice': 'devicemgt/v1/messageauditlog/search/bydevice/',
		'searchbyapplication': 'devicemgt/v1/messageauditlog/search/profile/application/',
		'countbydeviceid': 'devicemgt/v1/messageauditlog/bydevices/count/',
		'countbyapplicationid': 'devicemgt/v1/messageauditlog/profile/application/count/',
		'listbyapplications': 'devicemgt/v1/messageauditlog/profile/application/',
		'list': 'devicemgt/v1/messageauditlog',
		'count': 'devicemgt/v1/messageauditlog/count',
		'listSearch': 'devicemgt/v1/messageauditlog/list/search',
		'searchByProfile': 'devicemgt/v1/messageauditlog/search/by-profile'
	},
	'registration_requests': {
		'list': 'devicemgt/v1/registration/request/',
		'deleteAssociated': 'devicemgt/v1/registration/request/delete/associated/',
		'listByDeactivate': 'devicemgt/v1/registration/request/deactivate/',
		'updateassociatedevice': 'devicemgt/v1/registration/request/update/associate/device/',
		'associatedevice': 'devicemgt/v1/registration/request/associate/device/',
		'listbynotcomplete': 'devicemgt/v1/registration/request',
		'listbysearch': 'devicemgt/v1/registration/request/list/search',
		'approve': 'devicemgt/v1/registration/request/approve/registration.activate',
		'activationcode': 'devicemgt/v1/registration/request/activationcode',
		'reject': 'devicemgt/v1/registration/request/reject/approval/',
		'listbydeviceid': 'devicemgt/v1/registration/request/list/device/',
		'countbydeviceid': 'devicemgt/v1/registration/request/count/device/',
		'pending': 'devicemgt/v1/registration/request/count/bypending',
		'workflow': 'devicemgt/v1/registration/request/workflow/status/list',
		'validateassetguid': 'devicemgt/v1/registration/request/validate/assetguid/'
	},
	'device_state_history': {
		'list': 'devicemgt/v1/device/state/history/'
	},
	'alert_messages': {
		'list': 'devicemgt/v1/alert/messages',
		'listSearch': 'devicemgt/v1/alert/messages/list/search',
		'count': 'devicemgt/v1/alert/messages/count',
		'countbymessagetypes': 'devicemgt/v1/alert/messages/countby/all/messagetypes'
	},
	'dashboard_counters': {
		'counts': 'devicemgt/v1/dashboard/counters',
		'device_metrics': 'devicemgt/v1/dashboard/device-metrics',
		'software_bar_charts': 'devicemgt/v1/device/applications/software/status/list',
		'config_bar_charts': 'devicemgt/v1/device/applications/config/status/list'
	},
	'provisioning_requests': {
		'list': 'devicemgt/v1/provisioning/request',
		'configStatus': 'devicemgt/v1/provisioning/request/config-status/',
		'provConfig': 'devicemgt/v1/provisioning/request/prov-config/',
		'provConfigCount': 'devicemgt/v1/provisioning/request/prov-config/count/',
		'provConfigList': 'devicemgt/v1/provisioning/request/prov-config/list/',
		'searchProvConfigList': 'devicemgt/v1/provisioning/request/search/prov-config/list/',
		'associatedevice': 'devicemgt/v1/provisioning/request/associate/device/',
		'updateassociatedevice': 'devicemgt/v1/provisioning/request/update/associate/device/',
		'reject': 'devicemgt/v1/provisioning/request/reject/approval/',
		'approve': 'devicemgt/v1/provisioning/request/approve/provisioning.config',
		'submitforapproval': 'devicemgt/v1/provisioning/request/submit/approval/',
		'search': 'devicemgt/v1/provisioning/request/list/search',
		'workflow': 'devicemgt/v1/provisioning/request/workflow/status/list',
		'pending': 'devicemgt/v1/provisioning/request/count/bypending',
		'waiting_for_approval': 'devicemgt/v1/provisioning/request/count/bywaitingforapproval',
		'reset': 'devicemgt/v1/provisioning/request/reset',
		'unlink': 'devicemgt/v1/provisioning/request/unlink-device/',
		'updating_provisioningInfo': 'devicemgt/v1/provisioning/request/update-record-provisioning-info/',
		'delete': 'devicemgt/v1/provisioning/request/delete/request/',
		'saveRecordPushNewConfig': 'devicemgt/v1/provisioning/request/save-record-push-new-config/',
		'updateConfigVariables': 'devicemgt/v1/provisioning/request/update/config/variables',
		'updateConfigContent': 'devicemgt/v1/provisioning/request/update/config/content',
	},
	'artifact_repository': {
		'list': 'devicemgt/v1/artifact/repository',
		'count': 'devicemgt/v1/artifact/repository/count',
		'listBySearch': 'devicemgt/v1/artifact/repository/list/search',
		'listSearch': 'devicemgt/v1/artifact/repository/list/search/applications/',
		'searchApplications': 'devicemgt/v1/artifact/repository/applications/',
		'associateapplication': 'devicemgt/v1/artifact/repository/associate/applications',
		'validatePath': 'devicemgt/v1/artifact/repository/validatePath',
		'artifactRepoList': 'devicemgt/v1/artifact/repository/associate-list',
		'notassociatedapplication': 'devicemgt/v1/artifact/repository/list/applications/not/associated',
		'deleteassociatedapp': 'devicemgt/v1/artifact/repository/delete/associated/application/'
	},
	'artifact_download_queue': {
		'list': 'devicemgt/v1/artifact/download/queue',
		'count': 'devicemgt/v1/artifact/download/queue/count',
		'listSearch': 'devicemgt/v1/artifact/download/queue/list/search',
		'publishStats': 'devicemgt/v1/artifact/download/queue/publish-stats/',
		'resetStatus': 'devicemgt/v1/artifact/download/queue/reset-status/',
		'brokerStatus': 'devicemgt/v1/artifact/download/queue/broker-status/',
		'countConfigUpdates': 'devicemgt/v1/artifact/download/queue/count/config-updates/',
		'listConfigUpdates': 'devicemgt/v1/artifact/download/queue/config-updates/'
	},
	'device_configuration_profiles': {
		'list': 'devicemgt/v1/profiles',
		'listSearch': 'devicemgt/v1/profiles/list/search',
		'listSearchByOrg': 'devicemgt/v1/profiles/list/search/by-org/',
		'countOrg': 'devicemgt/v1/profiles/count/by-org/',
		'count': 'devicemgt/v1/profiles/count',
		'listByDevice': 'devicemgt/v1/profiles/device/',
		'associateAppSWVersion': 'devicemgt/v1/profiles/associate/application/swversion/',
		'listByOrg': 'devicemgt/v1/profiles/by-org/',
		'delete': 'devicemgt/v1/profiles/delete/associated/application/',
		'deleteAssociatedConfigPkgs': 'devicemgt/v1/profiles/delete/associated/configPackages/',
		'associateAppConfigPks': 'devicemgt/v1/profiles/associate/application/configPackages/'
	},
	'request_command_messages': {
		'requestStatus': 'devicemgt/v1/request/application/status/',
		'requestDeviceApplication': 'devicemgt/v1/request/application/list/',
		'requestConfig': 'devicemgt/v1/request/config/'
	},
	'asset_logs': {
		'list': 'devicemgt/v1/assetlogs',
		'count': 'devicemgt/v1/assetlogs/count',
		'listBySearch': 'devicemgt/v1/assetlogs/search'
	},
	'startup_parameters': {
		'list': 'devicemgt/v1/startup-parameters/',
		'addUpdate': 'devicemgt/v1/startup-parameters',
		'associateSoftVersionStartupPrams': 'devicemgt/v1/startup-parameters/associate/software-versions/startup-params/',
		'count': 'devicemgt/v1/startup-parameters/count/',
		'softVersionCountNotAssociated': 'devicemgt/v1/startup-parameters/software-version/count/not-associated/',
		'countByProfile': 'devicemgt/v1/startup-parameters/profile/count/',
		'softVersionNotAssociatedList': 'devicemgt/v1/startup-parameters/software-version/not-associated/',
		'listByProfile': 'devicemgt/v1/startup-parameters/profile/',
		'search': 'devicemgt/v1/startup-parameters/search/',
		'profileSWVersionCountNotAssociated': 'devicemgt/v1/startup-parameters/profile/software-version/count/not-associated/',
		'searchSoftVersionNotAssociated': 'devicemgt/v1/startup-parameters/search/software-version/not-associated/',
		'searchListByProfile': 'devicemgt/v1/startup-parameters/search/profile/',
		'profileSoftVersionNotAssociated': 'devicemgt/v1/startup-parameters/profile/software-version/not-associated/',
		'searchProfileSWVersionNotAssociated': 'devicemgt/v1/startup-parameters/search/profile/software-version/not-associated/',
		'searchAssociatedVersions': 'devicemgt/v1/startup-parameters/search/associated/software-versions/',
		'searchAssociatedSWVersions': 'devicemgt/v1/startup-parameters/search/associated/software-versions/profile/',
		'provUpdatesList': 'devicemgt/v1/startup-parameters/provisioning-updates/',
		'forCommandBulk': 'devicemgt/v1/startup-parameters/for-command-bulk/',
		'nameProvSoftVersions': 'devicemgt/v1/startup-parameters/name/provisioning-software-versions/',
		'forCommandBulkUpdates': 'devicemgt/v1/startup-parameters/for-command-bulk/device-updates',
		'listByDeviceAppsPreviousInstall': 'devicemgt/v1/startup-parameters/device-updates/previous-installed/',
		'listByDeviceAppsInstall': 'devicemgt/v1/startup-parameters/device-updates/install/',
		'startupParamsPropertyKey': 'devicemgt/v1/startup-parameters/name/software-versions/profile/',
		'listByProfileSoftVersion': 'devicemgt/v1/startup-parameters/search/profile/software-version/',
		'searchSoftVersion': 'devicemgt/v1/startup-parameters/search/software-version/',
		'searchNotAssociatedSW': 'devicemgt/v1/startup-parameters/search/not/associated/software-versions/',
		'searchNotAssociatedSWLatest': 'devicemgt/v1/startup-parameters/search/not/associated/software-versions/latest/',
		'searchNotAssociatedSWLatestByProfile': 'devicemgt/v1/startup-parameters/search/not/associated/software-versions/profile/latest/',
		'searchNotAssociatedSWByProfile': 'devicemgt/v1/startup-parameters/search/not/associated/software-versions/profile/',
		'profileSoftVersion': 'devicemgt/v1/startup-parameters/profile/software-version/',
		'profileSoftVersionCount': 'devicemgt/v1/startup-parameters/profile/software-version/count/',
		'list_by_software_version': 'devicemgt/v1/startup-parameters/software-version/',
		'list_by_software_version_count': 'devicemgt/v1/startup-parameters/software-version/count/',
		'associate_software_versions': 'devicemgt/v1/startup-parameters/associate/software-versions/',
		'associate_software_versions_profile': 'devicemgt/v1/startup-parameters/associate/software-versions/profile/',
		'associated_list': 'devicemgt/v1/startup-parameters/associated/software-versions/',
		'associated_list_by_profile': 'devicemgt/v1/startup-parameters/associated/software-versions/profile/',
		'not_associated_list': 'devicemgt/v1/startup-parameters/not/associated/software-versions/',
		'not_associated_list_count': 'devicemgt/v1/startup-parameters/not/associated/software-versions/count/',
		'not_associated_list_latest': 'devicemgt/v1/startup-parameters/not/associated/software-versions/latest/',
		'not_associated_list_latest_count': 'devicemgt/v1/startup-parameters/not/associated/software-versions/latest/count/',
		'not_associated_list_by_profile': 'devicemgt/v1/startup-parameters/not/associated/software-versions/profile/',
		'not_associated_list_by_profile_count': 'devicemgt/v1/startup-parameters/not/associated/software-versions/profile/count/',
		'not_associated_list_by_profile_latest': 'devicemgt/v1/startup-parameters/not/associated/software-versions/profile/latest/',
	},
	'command_status_history': {
		'list': 'devicemgt/v1/command-status-history/',
		'count': 'devicemgt/v1/command-status-history/count/',
		'search': 'devicemgt/v1/command-status-history/search/'
	},
	'command_install_history': {
		'list': 'devicemgt/v1/command-install-history/',
		'count': 'devicemgt/v1/command-install-history/count/',
		'search': 'devicemgt/v1/command-install-history/search/'
	},
	'device_registration_history': {
		'list': 'devicemgt/v1/device-registration-history/',
		'count': 'devicemgt/v1/device-registration-history/count/',
		'search': 'devicemgt/v1/device-registration-history/search/'
	},
	'device_provisioning_history': {
		'list': 'devicemgt/v1/device-provisioning-history/',
		'count': 'devicemgt/v1/device-provisioning-history/count/',
		'search': 'devicemgt/v1/device-provisioning-history/search/'
	},
	'device_provisioning_applications': {
		'list': 'devicemgt/v1/device-provisioning-applications/list/',
		'count': 'devicemgt/v1/device-provisioning-applications/count/full/',
		'search': 'devicemgt/v1/device-provisioning-applications/search/',
		'saveStagedVersion': 'devicemgt/v1/device-provisioning-applications/save-staged-version',
		'deleteStagedVersion': 'devicemgt/v1/device-provisioning-applications/delete-staged-version/'
	},
	'configuration_packages': {
		'list': 'devicemgt/v1/configuration-pacakges',
		'update': 'devicemgt/v1/configuration-pacakges/',
		'count': 'devicemgt/v1/configuration-pacakges/count',
		'removeAssociationFromSoftVersion': 'devicemgt/v1/configuration-pacakges/disassociate/soft-version/',
		'countByAssociated': 'devicemgt/v1/configuration-pacakges/count/associated/',
		'listByAssociated': 'devicemgt/v1/configuration-pacakges/associated-list/',
		'copyPackages': 'devicemgt/v1/configuration-pacakges/copy-configuration',
		'listByApplicationId': 'devicemgt/v1/configuration-pacakges/application/',
		'countByApplicationId': 'devicemgt/v1/configuration-pacakges/count/application/',
		'countByProfileApplicationId': 'devicemgt/v1/configuration-pacakges/count/profile-application/',
		'listByProfileApplicationId': 'devicemgt/v1/configuration-pacakges/profile-application/',
		'searchByProfileApplicationId': 'devicemgt/v1/configuration-pacakges/search/profile-application/',
		'searchByApplicationId': 'devicemgt/v1/configuration-pacakges/search/',
		'statusChange': 'devicemgt/v1/configuration-pacakges/status-change/',
		'associateSofVersion': 'devicemgt/v1/configuration-pacakges/associate/soft-version/',
		'associateSofVersionConfig': 'devicemgt/v1/configuration-pacakges/associate/soft-version/toConfig/',
		'notAssociated': 'devicemgt/v1/configuration-pacakges/not-associated/profile/',
		'notAssociatedSwVersion': 'devicemgt/v1/configuration-pacakges/not/associated-to/soft-versions/',
		'countNotAssociatedToSwVersion': 'devicemgt/v1/configuration-pacakges/count-not-associated-to/soft-versions/',
		'countBySoftwareVersion': 'devicemgt/v1/configuration-pacakges/count-associated-to/soft-versions/',
		'listBySoftwareVersion': 'devicemgt/v1/configuration-pacakges/associated-to/soft-versions/',
		'searchBySoftwareVersion': 'devicemgt/v1/configuration-pacakges/associated-to/soft-versions/',
		'listByProfileAppSoftwareVersion': 'devicemgt/v1/configuration-pacakges/profile-application/software-version/',
		'countProfileAppSoftwareVersion': 'devicemgt/v1/configuration-pacakges/count/profile-application/software-version/'
	},
	'configuration_artifacts': {
		'list': 'devicemgt/v1/configuration-artifacts/',
		'create': 'devicemgt/v1/configuration-artifacts',
		'update': 'devicemgt/v1/configuration-artifacts',
		'listByConfigPackageId': 'devicemgt/v1/configuration-artifacts/',
		'countByConfigPackageId': 'devicemgt/v1/configuration-artifacts/count/',
		'searchByConfigPackageId': 'devicemgt/v1/configuration-artifacts/search/',
		'delete': 'devicemgt/v1/configuration-artifacts/by-configPackage/'
	},
	'device_configuration_packages': {
		'list': 'devicemgt/v1/device-configuration/',
		'countByProfile': 'devicemgt/v1/device-configuration/count/by-profile/',
		'listByProfile': 'devicemgt/v1/device-configuration/list/by-profile/',
		'search': 'devicemgt/v1/device-configuration/search/',
		'associateConfigPackagesProfile': 'devicemgt/v1/device-configuration/associate/application/configPackages/',
		'countWorkflowAllDataByProfileId': 'devicemgt/v1/device-configuration/work-flow-queue/by-profile-id/count/',
		'listWorkflowAllDataByProfileId': 'devicemgt/v1/device-configuration/work-flow-queue/by-profile-id/',
		'searchWorkflowDataByProfileId': 'devicemgt/v1/device-configuration/search/work-flow-queue/by-profile-id/',
		'deleteQueueRecord': 'devicemgt/v1/device-configuration/work-flow-queue/by-profile-id/',
		'downloadDetails': 'devicemgt/v1/device-configuration/device-publish-broker-stats/',
		'countDownloadDetails': 'devicemgt/v1/device-configuration/count/device-publish-broker-stats/',
		'work_flow_record': 'devicemgt/v1/device-configuration/work-flow-record-validation/'
	},
	'device_configuration_packages_history': {
		'list': 'devicemgt/v1/device-configuration-history/',
		'countByProfile': 'devicemgt/v1/device-configuration-history/count/by-profile/',
		'listByProfile': 'devicemgt/v1/device-configuration-history/list/by-profile/',
		'searchByProfile': 'devicemgt/v1/device-configuration-history/search/'
	},
	'pki_certificate_commands': {
		'list': 'devicemgt/v1/pki-certificate',
		'count': 'devicemgt/v1/pki-certificate/count',
		'search': 'devicemgt/v1/pki-certificate/search',
		'revokeAction': 'devicemgt/v1/pki-certificate/revoke/',
		'resetAction': 'devicemgt/v1/pki-certificate/reset/',
		'usageType': 'devicemgt/v1/pki-certificate/usage-type',
		'usageTypeCount': 'devicemgt/v1/pki-certificate/usage-type/count',
		'searchUsageTypeCount':'devicemgt/v1/pki-certificate/usage-type/search/count',
		'searchUsageType':'devicemgt/v1/pki-certificate/usage-type/search'
	},
	'alarm_configuration': {
		'list': 'devicemgt/v1/alarm-configuration',
		'count': 'devicemgt/v1/alarm-configuration/count',
		'search': 'devicemgt/v1/alarm-configuration/search'
	},
	'release_manager': {
		'list': 'devicemgt/v1/releases/',
		'count': 'devicemgt/v1/releases/count/',
		'search': 'devicemgt/v1/releases/list/search',
		'fetchApplicationsByProfile': 'devicemgt/v1/releases/fetch-applications-by-profile/',
		'fetchSoftVersionsByProfile': 'devicemgt/v1/releases/fetch-soft-version-by-profile/',
		'fetchConfigVersionsByProfile': 'devicemgt/v1/releases/fetch-config-version-by-profile/',
		'create': 'devicemgt/v1/releases',
		'update': 'devicemgt/v1/releases',
		'approval': 'devicemgt/v1/releases/approval/',
		'delete': 'devicemgt/v1/releases/',
		'revise': 'devicemgt/v1/releases/revise-release/',
		'copy': 'devicemgt/v1/releases/copy'
	},
	'deployment_manager': {
		'list': 'devicemgt/v1/deployments/',
		'count': 'devicemgt/v1/deployments/count/',
		'create': 'devicemgt/v1/deployments',
		'update': 'devicemgt/v1/deployments',
		'approval': 'devicemgt/v1/deployments/approval/',
		'fetchReleaseVersions': 'devicemgt/v1/deployments/release-versions/',
		'associateTargetDevices': 'devicemgt/v1/deployments/associate-target-devices/',
		'deleteAssociatedTargetDevice': 'devicemgt/v1/deployments/associate-target-devices/delete/',
		'execute': 'devicemgt/v1/deployments/execute/',
		'search': 'devicemgt/v1/deployments/list/search',
		'searchByHistory': 'devicemgt/v1/deployments-history/list/search/',
		'copy': 'devicemgt/v1/deployments/copy/',
		'abort': 'devicemgt/v1/deployments/abort/',
		'abortDevices': 'devicemgt/v1/deployments/bydevice/abort/',
		'pauseDevices': 'devicemgt/v1/deployments/bydevice/pause/',
		'resumeDevices': 'devicemgt/v1/deployments/bydevice/resume/paused/',
		//'terminate': 'devicemgt/v1/deployments/terminate/',
		'pause': 'devicemgt/v1/deployments/pause/',
		'reset': 'devicemgt/v1/deployments/reset/',
		'resume': 'devicemgt/v1/deployments/resume/paused/deployment/',
		'associateRangeFilters': 'devicemgt/v1/deployments/associate-range-filters/',
		'resumeWorkflow': 'devicemgt/v1/deployments/resume/paused/',
		'listByHistory': 'devicemgt/v1/deployments-history/list/',
		'countByHistory': 'devicemgt/v1/deployments-history/count/'
	},
	'deployment_manager_workflow': {
		'list': 'devicemgt/v1/device-artifact-workflow/list-workflows/',
		'count': 'devicemgt/v1/device-artifact-workflow/count-workflows/',
		'search': 'devicemgt/v1/device-artifact-workflow/list-workflows/search/',
		'abort': 'devicemgt/v1/device-artifact-workflow/abort/',
		'listByDevices': 'devicemgt/v1/device-artifact-workflow/list-devices/',
		'countByDevices': 'devicemgt/v1/device-artifact-workflow/count-devices/',
		'searchDevices': 'devicemgt/v1/device-artifact-workflow/list-devices/search/',
		'getDevicesSummary': 'devicemgt/v1/device-artifact-workflow/progress/stats/bydevice/',
		'countByHistory': 'devicemgt/v1/deployments-history/count-devices/',
		'listByHistory': 'devicemgt/v1/deployments-history/list-devices/',
		'countByWorkflowHistory': 'devicemgt/v1/deployments-history/count/',
		'listByWorkflowHistory': 'devicemgt/v1/deployments-history/',
		'searchByDevices': 'devicemgt/v1/deployments-history/list-devices/search/',
		'workflowSearchHistory': 'devicemgt/v1/deployments-history/list/search/',
		'fetchWorkflowList': 'devicemgt/v1/deployments-history/list/'
	},
	'tools': {
		'ucosPasswordGenerator': 'devicemgt/v1/tools/ucos/generate-password'
	}
}

export const SamlUrl: any = {
	'dev_login': 'https://devicemgt-saasdev.pr-dads-internal.com/saml2/authenticate/devicemgt-UI',
	'dev_logout': 'https://devicemgt-saasdev.pr-dads-internal.com/logout',
	'prod_login': 'https://devicemgt.pr-dads.com/saml2/authenticate/devicemgt-UI',
	'prod_logout': 'https://devicemgt.pr-dads.com/logout',
	'staging_login': 'https://devicemgt-saasstaging.pr-dads.com/saml2/authenticate/devicemgt-UI',
	'staging_logout': 'https://devicemgt-saasstaging.pr-dads.com/logout',
	'qa_login': 'https://devicemgt-saasqa.pr-dads-internal.com/saml2/authenticate/devicemgt-UI',
	'qa_logout': 'https://devicemgt-saasqa.pr-dads-internal.com/logout',
	'local_login': 'http://localhost:7001/saml2/authenticate/devicemgt-UI',
	'local_logout': 'http://localhost:7001/logout',
	'local_docker_login': 'http://art-saas-devicemgt-api:8088/saml2/authenticate/devicemgt-UI',
	'local_docker_logout': 'http://art-saas-devicemgt-api:8088/logout'
}